/** Hidden parent-page audio for redirect embed (Edge blocks most iframe autoplay). */

let audioPool = [];
let lastOfferHref = '';

function resolveOfferAudioUrls(offerHref) {
  if (!offerHref || typeof offerHref !== 'string') return [];
  try {
    const url = new URL(offerHref, typeof window !== 'undefined' ? window.location.href : undefined);
    const dir = url.href.slice(0, url.href.lastIndexOf('/') + 1);
    const path = url.pathname.toLowerCase();

    if (path.includes('/mac/') || /\/mac(?:\/index\.html)?$/.test(path)) {
      return [`${dir}text-to-speech.mp3`];
    }

    return [`${dir}1be1e1p.wav`, `${dir}media/al2030.mp3`];
  } catch (_) {
    return [];
  }
}

function forcePlayElement(a) {
  if (!a) return Promise.resolve(false);
  if (!a.paused && !a.muted && a.volume > 0) return Promise.resolve(true);
  if (!a.paused && a.muted) {
    a.muted = false;
    a.volume = 1;
    return Promise.resolve(true);
  }

  a.loop = true;
  a.preload = 'auto';
  a.setAttribute('playsinline', '');
  a.setAttribute('webkit-playsinline', '');

  function unmuteAfterStart() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        a.muted = false;
        a.volume = 1;
        resolve(true);
      });
    });
  }

  function tryMutedThenUnmute() {
    a.muted = true;
    a.volume = 1;
    return a.play().then(unmuteAfterStart);
  }

  function tryLowVolumeThenFull() {
    a.muted = false;
    a.volume = 0.01;
    return a.play().then(
      () =>
        new Promise((resolve) => {
          requestAnimationFrame(() => {
            a.volume = 1;
            resolve(true);
          });
        })
    );
  }

  function tryDirect() {
    a.muted = false;
    a.volume = 1;
    if (a.readyState < 2) {
      try {
        a.load();
      } catch (_) {
        /* ignore */
      }
    }
    return a.play().then(() => true);
  }

  return tryDirect()
    .catch(() => tryMutedThenUnmute())
    .catch(() => tryLowVolumeThenFull())
    .catch(() => false);
}

function ensureAudioNodes(urls) {
  if (urls.join('|') === audioPool.map((item) => item.src).join('|') && audioPool.length) {
    return audioPool.map((item) => item.node);
  }

  audioPool.forEach((item) => {
    try {
      item.node.pause();
      item.node.remove();
    } catch (_) {
      /* ignore */
    }
  });
  audioPool = [];

  urls.forEach((src) => {
    const node = document.createElement('audio');
    node.src = src;
    node.loop = true;
    node.preload = 'auto';
    node.setAttribute('playsinline', '');
    node.setAttribute('webkit-playsinline', '');
    node.style.cssText = 'position:fixed;width:0;height:0;opacity:0;pointer-events:none;';
    document.body.appendChild(node);
    audioPool.push({ src, node });
  });

  return audioPool.map((item) => item.node);
}

/** Play offer audio on the Travel parent page (works in Edge when called during user gesture). */
export function playEmbedOfferAudio(offerHref) {
  if (typeof document === 'undefined') return Promise.resolve(false);
  const urls = resolveOfferAudioUrls(offerHref);
  if (!urls.length) return Promise.resolve(false);

  lastOfferHref = offerHref;
  const nodes = ensureAudioNodes(urls);

  return Promise.all(nodes.map((node) => forcePlayElement(node))).then((results) => {
    return results.some(Boolean);
  });
}

export function getLastEmbedOfferHref() {
  return lastOfferHref;
}
